import BaseAPI from '../base'

function getMyCafe() {
    return BaseAPI.get('cafe/my');
}

function updateCafe(cafe) {
    return BaseAPI.post(`cafe/update`, {
        cafe
    });
}

function updateCafeById(id, cafe) {
    return BaseAPI.post(`cafe/update/${id}`, {
        cafe
    });
}

function activateDelivery(promocode) {
    return BaseAPI.post(`cafe/activate_delivery/${promocode}`);
}

function getCorporateList() {
    return BaseAPI.get(`cafe/corporate_list`);
}

function createCorporateCafe(data) {
    return BaseAPI.post(`cafe/create_corporate_cafe`, data);
}

function getCafeById(id) {
    return BaseAPI.get(`cafe/my/${id}`);
}

function checkOnlineMenuLink(link) {
    return BaseAPI.get(`cafe/check_online_link/${link}`);
}

function setMode(cafe_id, mode, is_enabled) {
    return BaseAPI.post(`cafe/setMode/${cafe_id}/${mode}`, {
        is_enabled
    })
}

function setMenuMode(cafe_id, menu_id, mode, is_enabled) {
    return BaseAPI.post(`cafe/setMenuMode/${cafe_id}/${menu_id}/${mode}`, {
        is_enabled
    })
}

function connectCustomDomain(cafe_id, domain) {
    return BaseAPI.post(`cafe/connect_custom_domain`, {
        cafe_id,
        domain
    });
}

export default {
    getMyCafe,
    updateCafe,
    activateDelivery,
    getCorporateList,
    updateCafeById,
    createCorporateCafe,
    getCafeById,
    checkOnlineMenuLink,
    setMode,
    setMenuMode,
    connectCustomDomain
}